import { gql } from '@apollo/client';
import type {
  OpdsAccountType,
  OpdsAccountPageResponseType,
  OpdsAccountQueryConditionInput,
} from '../../../personnel/graphql/queries/queryOpdsAccountByPage';

export const QUERY_ACCOUNT_BY_RESOURCE_CODE_PAGE = gql`
  query QueryAccountByResourceCodePage(
    $resourceCode: String!
    $condition: OpdsAccountQueryConditionInput
    $pageRequest: PageRequestTypeInput
  ) {
    queryAccountByResourceCodePage(resourceCode: $resourceCode, condition: $condition, pageRequest: $pageRequest) {
      content {
        id
        name
        countryCode
        phone
        status
        employed
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface PageRequestTypeInput {
  page?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface QueryAccountByResourceCodePageResponse {
  queryAccountByResourceCodePage: OpdsAccountPageResponseType;
}

export interface QueryAccountByResourceCodePageVariables {
  resourceCode: string;
  condition?: OpdsAccountQueryConditionInput | null;
  pageRequest?: PageRequestTypeInput | null;
}

export type { OpdsAccountType, OpdsAccountQueryConditionInput };
